import React, { useEffect, useState } from "react";

//react-redux
import { useDispatch, useSelector, connect } from "react-redux";

//action
import { getOutOfCountryUserSetting } from "../store/outOfCountryUser/action";

//routing
import { Link } from "react-router-dom";

import OutOfCountryUserCard from "../component/outOfCountryUser/OutOfCountryUserCard";
import OutOfCountryUserDialog from "../component/dialog/OutOfCountryUserDialog";

const OutOfCountryUsers = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});

  useEffect(() => {
    props.getOutOfCountryUserSetting();
  }, []);

  const outOfCountryUserSetting = useSelector(
    (state) => state.outOfCountryUser.outOfCountryUserSetting,
  );

  useEffect(() => {
    if (outOfCountryUserSetting) {
      setData(outOfCountryUserSetting);
    }
  }, [outOfCountryUserSetting]);

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Out of Country Users</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Out of Country Users
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="row">
        <OutOfCountryUserCard data={data} />
      </div>

      <OutOfCountryUserDialog />
    </>
  );
};

export default connect(null, { getOutOfCountryUserSetting })(OutOfCountryUsers);
